import {
  ENABLE_BLOOM_UNIVERSAL_LANDING,
  getUnauthenticatedLandingPath,
} from '@/core/constants/appConfig';
import { useAuth } from '@/core/contexts/AuthContext';
import { BloomExperienceScreen } from '@/modules/bloom-experience';
import { Redirect, type Href } from 'expo-router';
import { Platform } from 'react-native';

/** Same destination splash / welcome use for signed-in users. */
const AUTHENTICATED_HOME = '/(auth)/(home)' as Href;

/**
 * App launch entry point (`/`).
 *
 * Authenticated home also resolves to `/` (Expo route groups are omitted from
 * the URL), so a browser refresh remounts this file. Wait for auth hydration,
 * then send signed-in users straight to home — do not bounce them through
 * Welcome / Universal landing.
 *
 * Unauthenticated behaviour is unchanged:
 * - Web → `getUnauthenticatedLandingPath()` (Welcome or Bloom Universal)
 * - Native → Bloom Experience when landing flag is on, else Welcome
 */
export default function Index() {
  const { isAuthenticated, isLoading } = useAuth();

  // Match AuthLayout: hold until store hydration so we never mis-route.
  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Redirect href={AUTHENTICATED_HOME} />;
  }

  if (Platform.OS === 'web') {
    return <Redirect href={getUnauthenticatedLandingPath() as Href} />;
  }

  if (!ENABLE_BLOOM_UNIVERSAL_LANDING) {
    return <Redirect href="/welcome" />;
  }

  return <BloomExperienceScreen />;
}
